import Vue from 'vue'
import Router from 'vue-router'
import pathResolver from '@/plugins/loader'
import store from '../store'

Vue.use(Router)
let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'homesite',
      component: pathResolver(null, 'homesite'),
      redirect: '/accueil',
      children: [
        {
          path: '/accueil',
          name: 'accueil',
          component: pathResolver('accueil'),
          meta: {
            requiresAuth: false
          }
        },
        {
          path: '/banking',
          name: 'banking',
          component: pathResolver('banking'),
          meta: {
            requiresAuth: false
          }
        },
        {
          path: '/assurance',
          name: 'assurance',
          component: pathResolver('assurance'),
          meta: {
            requiresAuth: false
          }
        },
        {
          path: '/sante',
          name: 'sante',
          component: pathResolver('sante'),
          meta: {
            requiresAuth: false
          }
        },
        {
          path: '/portfolio',
          name: 'portfolio',
          component: pathResolver('portfolio'),
          meta: {
            requiresAuth: false
          }
        },
        {
          path: '/equipe',
          name: 'equipe',
          component: pathResolver('equipe'),
          meta: {
            requiresAuth: false
          }
        },
        {
          path: '/carriere',
          name: 'carriere',
          component: pathResolver('carriere'),
          meta: {
            requiresAuth: false
          }
        }

      ]
    },
    {
      path: '/*',
      name: 'E404',
      component: pathResolver('errors', '404'),
      meta: {
        requiresAuth: false
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})
export default router
